export default __webpack_public_path__ + "static/media/WET.450c6288.png";